import { Component, EventEmitter, forwardRef, OnInit, Output, ViewChild } from '@angular/core';
import { Form, UntypedFormControl, NG_VALUE_ACCESSOR, Validators } from '@angular/forms';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDatepicker } from '@angular/material/datepicker';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { MatLegacyPaginator as MatPaginator, LegacyPageEvent as PageEvent } from '@angular/material/legacy-paginator';
import { Sort } from '@angular/material/sort';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { ActivatedRoute, Router } from '@angular/router';
import * as moment from 'moment';
import { Moment } from 'moment';
import { ToastrService } from 'ngx-toastr';
import { ModalAddPeriodeSageComponent } from 'src/app/shared/components/modals/modal-add-periode-sage/modal-add-periode-sage.component';
import { CustomDateAdapter } from 'src/app/shared/custom-date-adapter';
import { ReferentielDTO } from 'src/app/shared/dtos/referentielDTO';
import { SimpleQueryResponse } from 'src/app/shared/dtos/simpleQueryResponse';
import { SimpleQueryUser } from 'src/app/shared/dtos/simpleQueryUser';
import { SocieteModel } from 'src/app/shared/models/simple-types/societe.model';
import { PeriodeSageModel } from 'src/app/shared/models/societe-linked/periode-sage.model';
import { SocieteService } from 'src/app/shared/services/simple/societe.service';
import { PeriodeSageService } from 'src/app/shared/services/societe-linked/periode-sage.service';
import { GestionReferentielComponentService } from '../gestion-referentiel-component.service';   
import { NTHMonth, getMonth, getNumMonth, stringifyMonths } from 'src/app/shared/constants/month';

@Component({
  selector: 'app-gestion-periode-sage',
  templateUrl: './gestion-periode-sage.component.html',
  styleUrls: ['./gestion-periode-sage.component.scss']
})
export class GestionPeriodeSageComponent implements OnInit {
  periodes: PeriodeSageModel[] = [];
  displayedColumns: string[] = ['mois', 'date', 'statut'];
  dataSource: PeriodeSageModel[];
  matDataSource = new MatTableDataSource<PeriodeSageModel>([]);
  sortState: Sort = {active: 'code', direction: 'desc'};
  length: number;
  pageSize = 25;
  objet: SimpleQueryUser = new SimpleQueryUser();
  pageEvent: PageEvent;
  idSociete: number;
  societe: SocieteModel = new SocieteModel();
  result: boolean;
  _inputCtrl: UntypedFormControl = new UntypedFormControl();
  dateForm: UntypedFormControl;
  maxYear: number;
  annees = [];
  currentYear = new Date().getFullYear();
  @Output() onUpdated = new EventEmitter<boolean>();
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  constructor(
    public router: Router,
    public dialog: MatDialog,
    private route: ActivatedRoute,
    private toastrService: ToastrService,
    private gestionReferentielComponent: GestionReferentielComponentService,
    private periodeSageService: PeriodeSageService,
    private societeService: SocieteService,
  ) { 
    this.maxYear = new Date().getFullYear();
    this.dateForm = new UntypedFormControl(null, [Validators.required]);
    

  }

  ngOnInit(): void {
    this.route.params.subscribe((params: any) => {
      if (params.id === '0') {
        this.toastrService.error('Erreur durant la récupération de la societe.', 'Erreur');
        this.router.navigate(['/']);
      } else {
        this.societeService.get(params.id).subscribe((societe: SocieteModel) => {
          if (societe) {
            this.periodeSageService.getAllbySociete(societe.id).subscribe((res: any) => {
              this.periodes = res;
            });
            this.periodeSageService.getAllAnnee(societe.id).subscribe((res: any) => {
              this.annees = res;
              // add current year if not exist
              if(!this.annees.find(x => x === this.currentYear)){
                this.annees.push(this.currentYear);
              }
              // add next year if not exist
              if(!this.annees.find(x => x === this.currentYear + 1)){
                this.annees.push(this.currentYear + 1);
              }
              this.dateForm.setValue(this.currentYear);
              this.search();
            });
           this.idSociete = societe.id;
           this.societe = societe;
          }
        });
      }
    });
    this.router.routeReuseStrategy.shouldReuseRoute = function() {
       return false;
     };
  }

  getMonthbyNum(num: number): string{
    return getMonth(num);
  }

  search(): void {
    this.objet.pageNumber = 0;
    this.objet.pageSize = this.pageSize;
    this.loadPage();
  }

  loadPage(): void {
    if(this.dateForm.valid){
      this.periodeSageService.getAnnee(this.dateForm.value, this.idSociete).subscribe((periodes: PeriodeSageModel[]) => {
          let createdPeriodes = this.createPeriodes(periodes);
          this.matDataSource = new MatTableDataSource<PeriodeSageModel>(createdPeriodes);
        
      });
    } else{
      this.dateForm.markAsTouched();
      if(!this.dateForm.value || this.dateForm.value === ""){
        this.matDataSource = new MatTableDataSource<PeriodeSageModel>([]);
      }
    }
  }

  createPeriodes(periodes: PeriodeSageModel[]): PeriodeSageModel[]{
    let createdPeriodes = [];
    // creation de 12 periodes pour chaque mois
    for (let i = 1; i <= 12; i++) {
      let periode = periodes.find(p => p.mois === i);
      if(periode){
        createdPeriodes.push(periode);
      }else {
        periode = new PeriodeSageModel();
        periode.idSociete = this.idSociete;
        periode.mois = i;
        periode.annee = this.dateForm.value;
        periode.statut = "-";
        createdPeriodes.push(periode);
      }
      
    }
    return createdPeriodes;
  }

  onLeave(): void {
    this.router.navigate(['/gestion-referentiel']);
  }

  sortData(sort: Sort): void {
    if (sort.direction !== 'asc') {
      this.objet.descending = false;
    } else {
      this.objet.descending = true;
    }
    this.sortState = sort;
    this.objet.order = sort.active;
    this.loadPage();
  }

  openModal(periode: PeriodeSageModel): void {
    var suivant;
    var precedent;
    if(periode.mois !== 12){
      suivant = this.periodes.find(x => x.mois === periode.mois + 1 && x.annee === periode.annee);
    }else {
      suivant = this.periodes.find(x => x.mois === 1 && x.annee === periode.annee + 1);
    }
    if(periode.mois !== 1){
      precedent = this.periodes.find(x => x.mois === periode.mois - 1 && x.annee === periode.annee);
    }else {
      precedent = this.periodes.find(x => x.mois === 12 && x.annee === periode.annee - 1);
    }
    precedent = precedent ? precedent.date : null;
    suivant = suivant ? suivant.date : null;
    var form = this.gestionReferentielComponent.getEditPeriodeFormGroup(periode, suivant, precedent);
    const dialogRef = this.dialog.open(ModalAddPeriodeSageComponent, {
        autoFocus: false,
        disableClose: true,
        data: {
          form,
          societeId: this.idSociete,
          result: this.result
        }
      });

    dialogRef.afterClosed().subscribe(result => {
      this.onUpdated.emit(true);
      if (result) {
        this.loadPage();
        this.periodeSageService.getAllbySociete(this.idSociete).subscribe((res: any) => {
          this.periodes = res;
        });
      }
    });
  }

}
